export class PasswordCriteria {

    static readonly PW_MIN_LENGTH = 12;
    static readonly PW_MAX_LENGTH = 40;
    static readonly PW_CRITERIA_MAJUSCULE = /[A-Z\u00C0-\u00DD]/;
    static readonly PW_CRITERIA_MINUSCULE = /[a-z\u00DF-\u00FF]/;
    static readonly PW_CRITERIA_DIGIT = /[0-9]/;
    static readonly PW_CRITERIA_SPECIAL_CHAR = /[!?@(){}\[\]\\\/=~$%&#*\-+.,_]/;
    static readonly PW_CRITERIA_NO_OTHER_CHARS = /^[A-Za-z\u00C0-\u00FF0-9!?@(){}\[\]\\\/=~$%&#*\-+.,_]+$/;

    static readonly PW_ALL_CRITERIA = /^(?=.*[0-9])(?=.*[A-Z\u00C0-\u00DD])(?=.*[a-z\u00DF-\u00FF])(?=.*[!?@(){}\[\]\\\/=~$%&#*\-+.,_])(?!.* ).{12,40}$/

}
